import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, Row, Col, InputGroup } from 'react-bootstrap';
import './BookingForm.css';

const BookingForm = ({ show, handleClose, defaultService = '' }) => {
  const [validated, setValidated] = useState(false);
  const [status, setStatus] = useState("");
  const [formData, setFormData] = useState({
    type: '',
    subject: '',
    name: '',
    email: '',
    phone: '',
    city: '',
    service: defaultService || ''
  });

  const cities = [
    'Bangalore'
  ];

  const services = [
   'Nursing Attendant', 'Nursing Care', 'Care Giver', 'Mother & Baby Care','Physiotherapy','Doctor Consultation', 'ICU At Home',
    'IV & IM Injection', 'Lab Tests', "Parkinson's Care",
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    setValidated(true);
    
    if (form.checkValidity() === false) {
      event.stopPropagation();
      return;
    } else {
      // Here you would typically send the data to your backend
      console.log('Form submitted:', formData);
      alert('Booking request submitted successfully! We will contact you shortly.');
      handleClose();
      setFormData({
        name: '',
        email: '',
        phone: '',
        city: '',
        service: defaultService || ''
      });

      try {
        const payload = {
        ...formData,
        type: "services",        // or "services" / "equipment"
        subject: "Service Request", // you can make this dynamic if needed
        timestamp: new Date().getTime() // ensures uniqueness
      };
      const res = await fetch("https://script.google.com/macros/s/AKfycbxh0G5IHnJDGHNY9AyZakh0Mr9LWpPT4dO67qGJPsUAaMNXeKj1F4U75rQGBp83g8sRDg/exec", {
        method: "POST",
        body: JSON.stringify(payload),
      });

      if (res.ok) {
        setStatus("Message sent successfully!");
        setFormData({
        name: '',
        email: '',
        phone: '',
        city: '',
        service: ''
      });
        console.log(res);
      } else {
        setStatus("Failed to send message.");
         console.log(res);
      }
    } catch (error) {
      setStatus("Error: " + error.message);
       console.log(status);
    }
    }
  };

  // Reset validation state when modal is closed or reopened
  useEffect(() => {
    if (show) {
      setValidated(false);
    }
  }, [show]);

  return (
    <Modal show={show} onHide={() => {
      handleClose();
      setValidated(false);
    }} centered className="booking-modal">
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="fas fa-calendar-check me-2"></i>
          Book Medical Services At Your Home
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Row>
            <Col md={12}>
              <Form.Group className="mb-3" controlId="formName">
                <Form.Label>Full Name</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <i className="fas fa-user"></i>
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="Enter your full name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </InputGroup>
                <Form.Control.Feedback type="invalid">
                  Please provide your name.
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3" controlId="formEmail">
                <Form.Label>Email</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <i className="fas fa-envelope"></i>
                  </InputGroup.Text>
                  <Form.Control
                    type="email"
                    placeholder="Enter your email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </InputGroup>
                <Form.Control.Feedback type="invalid">
                  Please provide a valid email.
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3" controlId="formPhone">
                <Form.Label>Phone Number</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <i className="fas fa-phone"></i>
                  </InputGroup.Text>
                  <Form.Control
                    type="tel"
                    placeholder="Enter your phone number"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    pattern="[0-9]{10}"
                    required
                  />
                </InputGroup>
                <Form.Control.Feedback type="invalid">
                  Please provide a valid 10-digit phone number.
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3" controlId="formCity">
                <Form.Label>City</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <i className="fas fa-map-marker-alt"></i>
                  </InputGroup.Text>
                  <Form.Select 
                    name="city" 
                    value={formData.city}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select your city</option>
                    {cities.map((city, index) => (
                      <option key={index} value={city}>{city}</option>
                    ))}
                  </Form.Select>
                </InputGroup>
                <Form.Control.Feedback type="invalid">
                  Please select your city.
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3" controlId="formService">
                <Form.Label>Service</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <i className="fas fa-heartbeat"></i>
                  </InputGroup.Text>
                  <Form.Select 
                    name="service" 
                    value={formData.service}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select a service</option>
                    {services.map((service, index) => (
                      <option key={index} value={service}>{service}</option>
                    ))}
                  </Form.Select>
                </InputGroup>
                <Form.Control.Feedback type="invalid">
                  Please select a service.
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          
          <div className="d-grid gap-2 mt-4">
            <Button variant="primary" type="submit" className="booking-submit-btn">
              <i className="fas fa-paper-plane me-2"></i>
              Submit Booking Request
            </Button>
          </div>
          
          <div className="text-center mt-3 booking-info">
            <small className="text-muted">
              <i className="fas fa-shield-alt me-1"></i> Your information is secure and will not be shared
            </small>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default BookingForm;